import {
  prefectureOptions
} from '../../../const';
export type InputData = {
  [key: string]: string,
}
export const initialInputData: InputData = {
  userCode: "",
  firstNameKana: "",
  lastNameKana: "",
}
export type InputDataConfig = {
  [key: string]: {
    name: string,
    type: string,
    options?: {value: string, label: string}[],
    placeholder?: string,
    required?: boolean,
    caution?: string,
    pattern?: RegExp,
  }
}

export const inputDataConfig: InputDataConfig = {
  userCode: {
    name: "お客様コード",
    type: "text",
    placeholder: "例) 00100000",
    required: true,
  },
  lastNameKana: {
    name: "お名前(かな) [姓　※法人の場合は商号]",
    type: "text",
    placeholder: "例) やまだ",
    required: true,
  },
  firstNameKana: {
    name: "お名前(かな) [名　※法人の場合は担当者名]",
    type: "text",
    placeholder: "例) たろう",
    required: true,
  },
}
